import HundredBricksAPIError from '../../../HundredBricksAPIError';
class ProfitsSummaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ProfitsSummaryError', ...args);
    }
}
export default ProfitsSummaryError;
